module.exports = __webpack_public_path__ + "img/belatra.0c8e2ca6.svg";